import { delimiter } from '..';

/** Helper function to clean and join text sections */
export function cleanAndJoinText(text: (string | undefined)[]): string {
  return text.filter(text => !!text).join(delimiter);
}
